/**
 * WP Gallery
 *
 * Create Lightbox on each Image and Gallery Element from Gutenberg
 *
 */
const WPGallery = () => {
    // Variables
    const $galleries = [...document.querySelectorAll('.wp-block-gallery')];
    const $images = [...document.querySelectorAll('.wp-block-image')];

    if (!$galleries || !$images) {
        return false;
    }

    /**
     * Add data-caption on link base on figcaption content
     *
     * @param {array} elArray
     */
    function addDataCaption(elArray) {
        elArray.forEach(el => {
            let figcaption = el.querySelector('figcaption');
            let link = el.querySelector('a');
            if (figcaption && link) {
                link.setAttribute('data-caption', figcaption.innerHTML);
            }
        });
    }

    // Add Attributes Uk Lightbox on each WP Gallery
    $galleries.forEach(gallery => {
        let $galleryGrid = gallery.querySelector('.blocks-gallery-grid');
        if ( $galleryGrid ) {
            let $galleryItem = [...$galleryGrid.querySelectorAll('.blocks-gallery-item')];
            $galleryGrid.setAttribute('uk-lightbox', '');
            addDataCaption($galleryItem);
        }
    });

    // Add Attributes Uk Lightbox on each WP Image Link
    $images.forEach(image => {
        let $imageLink = image.querySelector('a'),
            figcaption = image.querySelector('figcaption');

        if (!$imageLink) {
            return;
        }

        image.setAttribute('uk-lightbox', '');

        if (figcaption) {
            $imageLink.setAttribute('data-caption', figcaption.innerHTML);
        }
    });
}

export default WPGallery;
